export default "__VITE_ASSET__4f7fe5fe__"